import React from 'react';

function Copy(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            enableBackground="new 0 0 512 512"
            viewBox="0 0 561 561"
            {...props}
        >
            <g xmlns="http://www.w3.org/2000/svg">
                <path
                    fill="#1e1e1e"
                    d="M395.25 0h-306c-28.05 0-51 22.95-51 51v357h51V51h306V0zm76.5 102h-280.5c-28.05 0-51 22.95-51 51v357c0 28.05 22.95 51 51 51h280.5c28.05 0 51-22.95 51-51V153c0-28.05-22.95-51-51-51zm0 408h-280.5V153h280.5v357z"
                    data-original="#000000"
                />
            </g>
        </svg>
    );
}

export default Copy;
